import { onBeforeUnmount, onMounted, ref } from "vue"

// A reactive "now" timestamp that refreshes on an interval, for lightweight
// live displays (e.g. countdowns) that don't need second-level precision.
export function useTickingClock(intervalMs: number) {
	const now = ref(Date.now())
	let timer: ReturnType<typeof setInterval> | null = null

	onMounted(() => {
		timer = setInterval(() => {
			now.value = Date.now()
		}, intervalMs)
	})

	onBeforeUnmount(() => {
		if (timer) {
			clearInterval(timer)
		}
	})

	return { now }
}
